import { render, staticRenderFns } from "./OfferingsList.vue?vue&type=template&id=b9687210&scoped=true&"
import script from "./OfferingsList.vue?vue&type=script&lang=js&"
export * from "./OfferingsList.vue?vue&type=script&lang=js&"
import style0 from "./OfferingsList.vue?vue&type=style&index=0&id=b9687210&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9687210",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9687210')) {
      api.createRecord('b9687210', component.options)
    } else {
      api.reload('b9687210', component.options)
    }
    module.hot.accept("./OfferingsList.vue?vue&type=template&id=b9687210&scoped=true&", function () {
      api.rerender('b9687210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/God/OfferingsList.vue"
export default component.exports